(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scratch-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('tq-scratch-popup')) return;

    function store(k, v) {
      try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; }
    }

    class TqScratchPopup extends HTMLElement {
      connectedCallback() {
        if (this._init) return; this._init = true;
        var d = this.dataset;
        this.key = d.key;
        this.design = d.design === 'true';
        this.threshold = parseFloat(d.threshold) || 0.75;
        this.cv = this.querySelector('[data-canvas]');
        this.ctx = this.cv.getContext('2d', { willReadFrequently: true });
        this.claimBtn = this.querySelector('[data-claim]');
        this.done = false;
        this.bind();

        if (this.design) {
          if (d.preview === 'true') this.open();
          document.addEventListener('shopify:section:select', (e) => { if (this.closest('[id^="shopify-section"]') && e.target.contains(this)) this.open(); });
          return;
        }
        /* claimed but never closed the code screen (e.g. the page reloaded): show the code again */
        var claimed = parseInt(store(this.key + '-claimed') || '0', 10);
        if (claimed && !store(this.key + '-done') && Date.now() - claimed < 864e5) {
          this.done = true; this.cv.classList.add('is-gone'); this.claimBtn.disabled = false;
          this.applyCode(); this.open(); this.step(3); return;
        }
        var seen = parseInt(store(this.key) || '0', 10);
        var days = parseInt(d.days, 10) || 0;
        if (seen && (days === 0 || Date.now() - seen < days * 864e5)) return;
        var delay = (parseFloat(d.delay) || 0) * 1000;
        this._t = setTimeout(() => this.open(), delay);
      }

      applyCode() {
        if (this.dataset.apply !== 'true' || this._applied) return;
        this._applied = true;
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        fetch(root + 'discount/' + encodeURIComponent(this.dataset.code), { credentials: 'same-origin' }).catch(function () {});
      }

      disconnectedCallback() { clearTimeout(this._t); document.documentElement.classList.remove('tq-sc-lock'); }

      open() {
        if (!this.hidden && this.classList.contains('is-open')) return;
        this.hidden = false;
        this.querySelectorAll('.tq-sc__img').forEach(function (i) { i.loading = 'eager'; });
        document.documentElement.classList.add('tq-sc-lock');
        this._last = document.activeElement;
        requestAnimationFrame(() => {
          this.classList.add('is-open');
          this.paint();
          var x = this.querySelector('.tq-sc__x'); if (x) x.focus({ preventScroll: true });
        });
        if (!this.design) store(this.key, String(Date.now()));
      }

      close() {
        if (store(this.key + '-claimed')) store(this.key + '-done', '1');
        this.classList.remove('is-open');
        document.documentElement.classList.remove('tq-sc-lock');
        setTimeout(() => { this.hidden = true; }, 400);
        if (this._last && this._last.focus) this._last.focus({ preventScroll: true });
      }

      step(n) {
        this.querySelectorAll('[data-step]').forEach(function (s) { s.classList.toggle('is-on', s.dataset.step === String(n)); });
        var f = this.querySelector('[data-step="' + n + '"] input, [data-step="' + n + '"] button');
        if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 300);
      }

      /* Scratch coating: matte champagne foil + SCRATCH HERE (no logo) */
      paint() {
        var cv = this.cv, ctx = this.ctx, r = cv.getBoundingClientRect();
        if (!r.width) return;
        var d = window.devicePixelRatio || 1, W = r.width, H = r.height;
        cv.width = Math.round(W * d); cv.height = Math.round(H * d);
        ctx.setTransform(d, 0, 0, d, 0, 0);
        ctx.globalCompositeOperation = 'source-over';
        var g = ctx.createLinearGradient(0, 0, W, H);
        g.addColorStop(0, '#a59876'); g.addColorStop(.5, '#b5a983'); g.addColorStop(1, '#9c8f6e');
        ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
        var img = ctx.getImageData(0, 0, cv.width, cv.height), px = img.data;
        for (var i = 0; i < px.length; i += 4) { var n = (Math.random() - .5) * 26; px[i] += n; px[i + 1] += n; px[i + 2] += n * .9; }
        ctx.putImageData(img, 0, 0);
        var sh = ctx.createRadialGradient(W * .3, H * .25, 0, W * .3, H * .25, W * .9);
        sh.addColorStop(0, 'rgba(255,250,235,.10)'); sh.addColorStop(1, 'rgba(0,0,0,.08)');
        ctx.fillStyle = sh; ctx.fillRect(0, 0, W, H);
        ctx.strokeStyle = 'rgba(70,60,40,.35)'; ctx.lineWidth = 2; ctx.setLineDash([4, 4]); ctx.strokeRect(10, 10, W - 20, H - 20); ctx.setLineDash([]);
        ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
        var font = getComputedStyle(this).fontFamily || 'Inter, sans-serif';
        ctx.fillStyle = 'rgba(37,36,34,.75)'; ctx.font = '800 24px ' + font;
        ctx.fillText(this.dataset.scratchText || 'SCRATCH HERE', W / 2, H / 2);
        ctx.globalCompositeOperation = 'destination-out';
      }

      cleared() {
        var px = this.ctx.getImageData(0, 0, this.cv.width, this.cv.height).data, n = 0, c = 0;
        for (var i = 3; i < px.length; i += 64) { c++; if (px[i] === 0) n++; }
        return n / c;
      }

      reveal() {
        if (this.done) return;
        this.done = true;
        this.cv.classList.add('is-gone');
        this.claimBtn.disabled = false;
        if (navigator.vibrate) navigator.vibrate(30);
      }

      bind() {
        var self = this, cv = this.cv, ctx = this.ctx, hint = this.querySelector('[data-hint]');
        var drawing = false, last = null, chk = 0;
        function pt(e) { var r = cv.getBoundingClientRect(); return { x: e.clientX - r.left, y: e.clientY - r.top }; }
        function scratch(p) {
          ctx.strokeStyle = '#000'; ctx.lineWidth = 40; ctx.lineCap = 'round';
          ctx.beginPath(); ctx.moveTo((last || p).x, (last || p).y); ctx.lineTo(p.x, p.y); ctx.stroke();
          last = p; if (hint) hint.style.opacity = 0;
        }
        cv.addEventListener('pointerdown', function (e) { drawing = true; last = null; try { cv.setPointerCapture(e.pointerId); } catch (x) {} scratch(pt(e)); });
        cv.addEventListener('pointermove', function (e) { if (!drawing) return; scratch(pt(e)); if (++chk % 8 === 0 && self.cleared() > self.threshold) self.reveal(); });
        function up() { if (!drawing) return; drawing = false; if (self.cleared() > self.threshold) self.reveal(); }
        cv.addEventListener('pointerup', up); cv.addEventListener('pointercancel', up);
        cv.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); self.reveal(); } });

        this.claimBtn.addEventListener('click', function () { if (self.done) self.step(2); });

        var form = this.querySelector('.tq-sc__signup') || this.querySelector('form');
        if (form) {
          var frame = this.querySelector('.tq-sc__frame');
          if (frame) form.setAttribute('target', frame.name);
          form.addEventListener('submit', function (e) {
            if (!form.checkValidity()) { e.preventDefault(); form.reportValidity(); return; }
            if (self._sent) { e.preventDefault(); return; }
            self._sent = true;
            /* no preventDefault: the form posts into the hidden iframe, so the page stays put
               (this also works with Shopify's captcha, which re-submits the form itself) */
            store(self.key + '-claimed', String(Date.now()));
            self.applyCode();
            setTimeout(function () { self.step(3); }, 0);
          });
        }

        var copy = this.querySelector('[data-copy]');
        if (copy) copy.addEventListener('click', function () {
          var code = self.dataset.code, label = copy.textContent;
          var ok = function () { copy.textContent = 'Copied ✓'; setTimeout(function () { copy.textContent = label; }, 1600); };
          if (navigator.clipboard) navigator.clipboard.writeText(code).then(ok, ok); else ok();
        });

        this.querySelectorAll('[data-close]').forEach(function (b) { b.addEventListener('click', function () { self.close(); }); });
        this.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') self.close();
          if (e.key === 'Tab') {
            var f = Array.prototype.filter.call(self.querySelectorAll('button:not([disabled]), input, canvas, a[href]'), function (el) { return el.offsetParent !== null; });
            if (!f.length) return;
            if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
            else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
          }
        });
        window.addEventListener('resize', function () { if (!self.done && !self.hidden) self.paint(); });
      }
    }
    customElements.define('tq-scratch-popup', TqScratchPopup);
  })();

  } catch(e) { console.error(e); }
})();
})();
